import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule, MatIconRegistry } from '@angular/material/icon';
import { MbIconComponent } from './mb-icon.component';

@NgModule({
    declarations: [MbIconComponent],
    imports: [CommonModule, MatIconModule],
    exports: [MbIconComponent],
})
export class MbIconModule {
    public constructor(private registry: MatIconRegistry) {
        this.registry.registerFontClassAlias('mb', 'mb');
    }
}
